import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ConstantsService } from '../constants.service';

@Injectable({
  providedIn: 'root'
})
export class CommonHelperService {

    constructor(private constants: ConstantsService) { }

    Dates: any = {

        GetWeeklyCycleWeekNumberChar: (date: any, dateCycle: any) => {
            let weekAStartsOn = dateCycle && moment(new Date(dateCycle)).isValid() ? moment(new Date(dateCycle)) : moment(this.constants.Dates.WeekAStartsOn, 'MM-DD-YYYY');
            let momentDate = date && moment(date).isValid() ? moment(date) : moment(this.constants.Dates.WeekAStartsOn, 'MM-DD-YYYY');
            let weeksOfYearDifference = (moment(momentDate)).diff(moment(weekAStartsOn), 'week');
            let weeklyCycleWeekNumber = weeksOfYearDifference % 2;

            if (weeklyCycleWeekNumber === 0) {
                return 'A';
            } else {
                return 'B';
            }
            
            return '';
        }
    }

    Time: any = {

        GetFormattedAMPMTime: (time: string) => {

            if (time && moment(time, 'hh:mm A').isValid()) {
                return moment(time, 'hh:mm A').format('hh:mm A');
            }

            return time;
        }
    }

    IsCayuseOneLogin(userData: any): boolean {
        return userData && userData.loginType === this.constants.LoginTypes.Cayuse;
    }
}
